import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PopupLayout from 'components/PopupLayout';
import PopupTermCond from 'components/PopupTermCond';
import EcommerceFormatItem from 'components/EcommerceFormatItem';
import CouponService from 'services/Coupon/service';
import './style.scss';

const EcommerceFormat = ({ 
    coupons = [], 
    hasSession = false,
    handleEcomerceCategorieProcessChange=null 
    }) => {

    const [showTermConditions, setShowTermConditions] = useState();
    const [popupLegalText, setPopupLegalText] = useState('');
    const [valueCopy,setValueCopy]=useState("");
    const openTermConditions = (event, couponValue = null) => {
        event.preventDefault();
        if(!hasSession) return;
        const newTermCondition = !showTermConditions;
        setPopupLegalText('');
        if(newTermCondition){
            Promise.all([CouponService.getCouponDetail(couponValue.id)]).then(detail => {
                if(detail && detail[0].legal)
                    setPopupLegalText(`${detail[0].legal.availableDates}<br>${detail[0].legal.legalMessage}`);
            });
        }
        setShowTermConditions(newTermCondition);
    }
    const handleEcomerceProcessChange=()=>{
        handleEcomerceCategorieProcessChange();
    }
    const handleValueCopy=(valueBarcode)=>{
        setValueCopy(valueBarcode);
    }
    
    return (
        <>
        <div className="slick-coupon horizontal no-slick">
            {coupons.map( (row, keyRow) => {
                return (
                    <EcommerceFormatItem 
                        key={keyRow} 
                        indexPos={keyRow} 
                        coupon={row}
                        controlTerms={openTermConditions} 
                        hasSession={hasSession} 
                        showExclusivePic={true}
                        handleEcomerceFormatProcessChange={handleEcomerceProcessChange}
                        handleEcomerceFormatValueCopy={handleValueCopy}
                        value={valueCopy}
                        />
                )
            })}
        </div>
        <PopupLayout isShowwing={showTermConditions} showingCallback={openTermConditions}>
            <PopupTermCond execActionConfirm={openTermConditions} popupLegalText={popupLegalText} />
        </PopupLayout>
        <br /><br /><br />
        </>
    );
}

EcommerceFormat.propTypes = {
    coupons: PropTypes.array, 
    hasSession: PropTypes.bool,
    handleEcomerceCategorieProcessChange:PropTypes.func
};

export default EcommerceFormat;